import React, { useContext } from 'react';
import Collapse from 'antd/lib/collapse';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import find from 'lodash/find';
import { PaymentDetailsContext } from '../forms/payment/PaymentDetailsForm';
import { DeclaredComponent } from '../DynamicComponent';

const SectionHeader = ({ header }) => {
  if (!header) return null;

  return <Rows rows={header} />;
};

const Columns = ({ columns }) => {
  return columns.map((column, index) => {
    const componentId = Object.keys(column)[0];
    const span = column[componentId].span ? column[componentId].span : '';
    const styleProps = column[componentId].span
      ? column[componentId].styleProps
      : null;
    return (
      <Col key={index} span={span}>
        <div style={styleProps}>
          <DeclaredComponent declaration={column} />
        </div>
      </Col>
    );
  });
};

const Rows = ({ rows, collapse }) => {
  return rows.map(({ Group }, index) => {
    const columns = Group.content;

    return (
      <Row key={index} style={{ paddingLeft: '16px' }}>
        <Columns columns={columns} />
      </Row>
    );
  });
};

const CollapseRow = ({ rows, sectionHeader }) => {
  const { paymentPlans } = useContext(PaymentDetailsContext);
  const { Panel } = Collapse;
  const styles = {
    container: {
      display: 'flex',
      flex: 24
    },
    col: span => ({
      flex: span,
      textAlign: 'right'
    })
  };

  if (
    !rows ||
    !Array.isArray(rows) ||
    !paymentPlans ||
    paymentPlans.length <= 0
  )
    return null;

  const Header = ({ plan, planIndex }) => {
    const {
      name,
      downPaymentAmt,
      installmentAmt,
      installmentFeeAmt,
      totalAmt
    } = plan;

    return (
      <div style={styles.container}>
        <div
          style={{
            ...styles.col(8),
            textAlign: 'left'
          }}
        >
          {name}
        </div>

        <div style={styles.col(4)}>{downPaymentAmt}</div>

        <div style={styles.col(4)}>{installmentAmt}</div>

        <div style={styles.col(4)}>
          {installmentFeeAmt ? installmentFeeAmt : '-'}
        </div>

        <div style={styles.col(4)}>{totalAmt}</div>
      </div>
    );
  };

  return (
    <Collapse bordered={false} accordion>
      {rows.map(({ name }, index) => {
        const plan = find(paymentPlans, plan => {
          return plan.name.toLowerCase() === name.toLowerCase();
        });
        return (
          <Panel
            key={index}
            header={<Header planIndex={index} plan={plan} />}
            style={{ paddingTop: '15px', paddingBottom: '15px' }}
          >
            <div
              style={{
                ...styles.container,
                paddingLeft: '30px'
              }}
            >
              <div
                style={{
                  ...styles.col(12),
                  textAlign: 'left'
                }}
              >
                # of Installments {plan.numberOfInstallments}
              </div>
              <div
                style={{
                  ...styles.col(12),
                  textAlign: 'left'
                }}
              >
                Total # of Payments {plan.numberOfPayments}
              </div>
            </div>
          </Panel>
        );
      })}
    </Collapse>
  );
};

export const CollapseTable = ({ rows, header }) => {
  return (
    <>
      <SectionHeader header={header} />
      <CollapseRow rows={rows} sectionHeader={header} />
    </>
  );
};
